"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";

const IMAGE_BASE = "/image/new-version/fabrication/metal-stamping/Stamping-Services";

const CARDS = [
	{ key: "typesCard1", image: `${IMAGE_BASE}/progressive-die-stamping.webp` },
	{ key: "typesCard2", image: `${IMAGE_BASE}/single-operation-stamping.webp` },
	{ key: "typesCard3", image: `${IMAGE_BASE}/compound-die-stamping.webp` },
	{ key: "typesCard4", image: `${IMAGE_BASE}/deep-drawing-stamping.webp` },
	{ key: "typesCard5", image: `${IMAGE_BASE}/bending-stamping.webp` },
	{ key: "typesCard6", image: `${IMAGE_BASE}/custom-stamping-solutions.webp` },
] as const;

const QUOTE_HREF = "/upload";

export default function TypesOfMetalStamping() {
	const t = useTranslations("new-stamping");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("typesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("typesDesc")}</p>
				</header>

				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{CARDS.map((card) => (
						<article
							key={card.key}
							className="flex flex-col overflow-hidden rounded-xl border-2 border-[#7d7d7d] bg-white shadow-sm transition-shadow hover:shadow-md"
						>
							<div className="relative aspect-[16/8] w-full overflow-hidden bg-[#f5f5f5]">
								<Image
									src={card.image}
									alt={t(`${card.key}Alt`)}
									fill
									className="object-cover"
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
								/>
							</div>
							<div className="flex flex-1 flex-col p-5">
								<h3 className="mb-2 text-lg font-bold text-black sm:mb-3 sm:text-xl md:text-2xl">
									{t(`${card.key}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(`${card.key}Desc`)}</p>
							</div>
						</article>
					))}
				</div>

				<div className="mt-8 flex justify-center sm:mt-10 md:mt-12">
					<Link
						href={QUOTE_HREF}
						target={QUOTE_HREF}
						className="inline-flex w-fit items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("typesGetQuote")}
					</Link>
				</div>
			</div>
		</section>
	);
}
